import React, { useState } from "react";
import AddToWishlistButton from "./AddToWishlistButton";

const ArtprintsStCards = ({ ImgSrc, ImgJpg, ImgJpeg, title, desc, isDesktop, item, showWishlistButton = true }) => {
  const [currentImg, setCurrentImg] = useState(ImgSrc);
  const [loaded, setLoaded] = useState(false); // Track when image loads
  const [imageError, setImageError] = useState(false); // Track if primary image failed

  const imageWrapperClass = `aspect-square w-full overflow-hidden rounded-xl relative group transition-shadow duration-500 ${
    loaded ? 'shadow-xl shadow-gray-400' : 'shadow-none'
  }`;

  const imageClass = `w-full h-full object-contain rounded-xl transition-all duration-300 group-hover:scale-105 group-hover:rounded-none`;

  // Handle image load error and fallback to jpeg
  const handleImageError = () => {
    if (!imageError && ImgJpeg) {
      setCurrentImg(ImgJpeg);
      setImageError(true);
    }
  };

  // Handle successful image load
  const handleImageLoad = () => {
    setLoaded(true);
  };

  // Create item object for wishlist if not provided
  const wishlistItem = item || {
    title,
    desc,
    Img: ImgSrc,
    ImgJpg,
    ImgJpeg
  };

  const desktopWrapper = (
    <div className="w-[350px] lg:w-[380px]">
      <button className="w-full">
        <div className={imageWrapperClass}>
          <img
            className={imageClass}
            src={currentImg}
            alt={title}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
          {/* Wishlist button positioned absolutely */}
          {showWishlistButton && (
            <div className="absolute top-2 right-2 z-10">
              <AddToWishlistButton 
                item={wishlistItem}
                size="small"
              />
            </div>
          )}
        </div>
        <div className="p-3 text-center">
          <p className="text-gray-500 text-xs pt-0">{title}</p>
          <p className="text-gray-700 text-base pt-0">{desc}</p>
        </div>
      </button>
    </div>
  );

  const mobileWrapper = (
    <div className="w-full">
      <button className="w-full">
        <div className={imageWrapperClass}>
          <img
            className={imageClass}
            src={currentImg}
            alt={title}
            onLoad={handleImageLoad}
            onError={handleImageError}
          />
          {/* Wishlist button positioned absolutely */}
          {showWishlistButton && (
            <div className="absolute top-2 right-2 z-10">
              <AddToWishlistButton 
                item={wishlistItem}
                size="small"
              />
            </div>
          )}
        </div>
        <div className="p-2 text-center">
          <p className="text-gray-500 text-xs pt-0">{title}</p>
          <p className="text-gray-800 text-base pt-0">{desc}</p>
        </div>
      </button>
    </div>
  );

  return isDesktop ? desktopWrapper : mobileWrapper;
};

export default ArtprintsStCards;
